export const FacebookLinked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="55.614"
    viewBox="0 0 64 55.614"
  >
    <g
      id="Facebook_Solid"
      data-name="Facebook Solid"
      transform="translate(-0.104)"
    >
      <circle
        id="Ellipse_4"
        data-name="Ellipse 4"
        cx="27.5"
        cy="27.5"
        r="27.5"
        transform="translate(0.104)"
        fill="#fff"
      />
      <path
        id="Path_2101"
        data-name="Path 2101"
        d="M323.516-799.82l1.193-7.78h-7.464v-5.049c0-2.128,1.043-4.2,4.386-4.2h3.394v-6.624A41.389,41.389,0,0,0,319-824c-6.148,0-10.166,3.726-10.166,10.471v5.929H302v7.78h6.834v18.808a27.128,27.128,0,0,0,4.205.327,26.952,26.952,0,0,0,4.188-.2l.018-18.936h6.271"
        transform="translate(-286.165 836.298)"
        fill="#135cb0"
        fillRule="evenodd"
      />
      <g id="Group_2957" data-name="Group 2957" transform="translate(45.33)">
        <g
          id="Ellipse_55"
          data-name="Ellipse 55"
          transform="translate(-0.226)"
          fill="#135cb0"
          stroke="#fff"
          strokeWidth="1.5"
        >
          <circle cx="9.5" cy="9.5" r="9.5" stroke="none" />
          <circle cx="9.5" cy="9.5" r="8.75" fill="none" />
        </g>
        <g
          id="Link_Chain_-_S"
          data-name="Link Chain - S"
          transform="translate(4.776 4.999)"
        >
          <path
            id="Link_Chain_-_S-2"
            data-name="Link Chain - S"
            d="M9.23,1.784,8.207.761a.965.965,0,0,0-1.325,0L4.673,2.971a.949.949,0,0,0,0,1.326l.2.2-.376.376-.188-.2a.965.965,0,0,0-1.325,0L.77,6.882A.941.941,0,0,0,.77,8.2L1.793,9.222a.933.933,0,0,0,.663.278.949.949,0,0,0,.663-.27L5.327,7.021a.949.949,0,0,0,0-1.326l-.2-.2L5.5,5.123l.2.2a.965.965,0,0,0,.663.27.949.949,0,0,0,.663-.27L9.23,3.11A.949.949,0,0,0,9.23,1.784ZM2.456,8.608h0l-1.047-1.1L3.666,5.3l.188.2-.622.622a.45.45,0,0,0,.319.761.417.417,0,0,0,.311-.131l.614-.605.213.229ZM6.358,4.7h0l-.2-.2.63-.622a.451.451,0,1,0-.638-.638l-.605.614-.237-.237L7.569,1.4,8.592,2.48Z"
            transform="translate(-0.501 -0.498)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
